module.exports = "<div class=\"admin-banner-container\" [auth-level] level=\"sadmin\" *ngIf=\"isLoggedIn && account !== 'Siftrock Demo' && account !== 'Siftrock Dev' && account !== 'Siftrock QA'\">\n  <h5 class=\"admin-banner-text\">You are viewing {{account}}'s account</h5>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/admin-banner/admin-banner.component.html
// module id = ./client/app/admin/admin-banner/admin-banner.component.html
// module chunks = main